export default interface SerStation {
    id: number;
    name: string;
}

export const serStationDefaultProps: SerStation = {
    id: 0,   
    name: "",
}